const GoogleCard = ({
  children,
  backgroundColour,
  googleDarkBackgroundColour,
  fgColour
}) => {
  try {
    const styles = {
      card: {
        background: `linear-gradient(
          to bottom,
          ${backgroundColour} 0px,
          ${backgroundColour} 350px,
          ${googleDarkBackgroundColour} 750px,
          ${googleDarkBackgroundColour} 100%
        )`,
        color: fgColour,
      },
    };

    return (
      <div className="google-card">
        <div style={styles.card} className="front" id="googleFront">
          {children}
        </div>
      </div>
    );
  } catch (err) {
    throw err;
  }
};

export default GoogleCard;